import { useTheme, useMediaQuery } from '@mui/material';
import DashboardStudioDesktop from './DashboardStudioDesktop';
import DashboardStudioMobile from './DashboardStudioMobile';

export default function DashboardStudioPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile
    ? <DashboardStudioMobile />
    : <DashboardStudioDesktop />;
}